module.exports = __webpack_public_path__ + "img/p-1.f720940a.jpg";